module.exports = __webpack_public_path__ + "static/media/brush_3.b0932cd2.png";